const formatMoney = (cents) => {
  const amount = Number(cents || 0) / 100;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'INR',
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2
  }).format(amount);
};

const escapeHtml = (value) =>
  String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-mobile-menu-toggle]');
  if (menuToggle) {
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (drawer) drawer.classList.toggle('is-open');
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-product-gallery]') || document;
    const mainImage = gallery.querySelector('[data-main-product-image]') || document.querySelector('[data-main-product-image]');
    if (mainImage) mainImage.src = thumb.dataset.galleryThumb;
    const activeIndex = thumb.dataset.galleryIndex;
    if (activeIndex !== undefined) {
      gallery.querySelectorAll('[data-gallery-index]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.galleryIndex === activeIndex);
      });
    }
  }

  const shareButton = event.target.closest('[data-share-product]');
  if (shareButton) {
    if (navigator.share) {
      navigator.share({ title: document.title, url: window.location.href }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href);
    }
  }

  const qtyMinus = event.target.closest('[data-qty-minus], [data-cart-qty-minus]');
  const qtyPlus = event.target.closest('[data-qty-plus], [data-cart-qty-plus]');
  if (qtyMinus || qtyPlus) {
    const wrap = event.target.closest('.qty-stepper');
    const input = wrap?.querySelector('input');
    if (!input) return;
    const current = Number(input.value || 1);
    const next = qtyMinus ? Math.max(Number(input.min || 0), current - 1) : current + 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.querySelectorAll('.product-form').forEach((form) => {
  const variantSelect = form.querySelector('[data-variant-select]');
  const variantsScript = document.querySelector('[data-product-variants-json]');
  const price = document.querySelector('[data-selected-price]');
  const compare = document.querySelector('[data-selected-compare]');
  const save = document.querySelector('[data-selected-save]');
  const addButtons = Array.from(form.querySelectorAll('[data-add-to-cart], [data-buy-now]'));
  const addTexts = Array.from(form.querySelectorAll('[data-add-text]'));
  const mainImage = document.querySelector('[data-main-product-image]');
  const stickyBuy = form.querySelector('[data-mobile-sticky-buy]');
  const buyButtons = form.querySelector('.buy-buttons');
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
  if (!variantSelect) return;

  const selectedOptions = [];
  form.querySelectorAll('[data-option-groups] [data-option-position]').forEach((group) => {
    const position = Number(group.dataset.optionPosition);
    const active = group.querySelector('[data-option-choice].is-active');
    if (active) selectedOptions[position - 1] = active.dataset.optionValue;
  });

  const updateFromSelect = () => {
    const option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return;
    if (price) price.textContent = option.dataset.price || price.textContent;
    if (compare) compare.textContent = option.dataset.compare || '';
    const compareRaw = Number(option.dataset.compareRaw || 0);
    const priceRaw = Number(option.dataset.priceRaw || 0);
    if (save) save.textContent = compareRaw > priceRaw ? `Save ${formatMoney(compareRaw - priceRaw)}` : '';
    const available = option.dataset.available === 'true' && !option.disabled;
    addButtons.forEach((button) => {
      button.disabled = !available;
    });
    addTexts.forEach((text) => {
      const button = text.closest('[data-add-to-cart]');
      text.textContent = available ? (button?.dataset.addLabel || 'Add to cart') : 'Sold out';
    });
    if (mainImage && option.dataset.image) mainImage.src = option.dataset.image;
  };

  const updateVariant = () => {
    if (!selectedOptions.length) {
      updateFromSelect();
      return;
    }
    const variant = variants.find((candidate) =>
      candidate.options.every((value, index) => String(value) === String(selectedOptions[index]))
    );
    if (!variant) return;
    variantSelect.value = String(variant.id);
    updateFromSelect();
  };

  form.querySelectorAll('[data-option-choice]').forEach((choice) => {
    choice.addEventListener('click', () => {
      const position = Number(choice.dataset.optionPosition);
      selectedOptions[position - 1] = choice.dataset.optionValue;
      form.querySelectorAll(`[data-option-choice][data-option-position="${position}"]`).forEach((button) => {
        const active = button === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const label = form.querySelector(`[data-selected-option="${position}"]`);
      if (label) label.textContent = choice.dataset.optionValue;
      updateVariant();
    });
  });

  variantSelect.addEventListener('change', updateFromSelect);
  updateFromSelect();

  if (stickyBuy && buyButtons) {
    const media = window.matchMedia('(max-width: 767px)');
    const updateSticky = () => {
      const visible = buyButtons.getBoundingClientRect().bottom < 0;
      const show = media.matches && visible;
      stickyBuy.classList.toggle('is-visible', show);
      stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-mobile-sticky-buy', show);
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    media.addEventListener?.('change', updateSticky);
    updateSticky();
  }
});

const syncProductGalleryHeights = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.main-image');
    if (!mainImage) return;
    const height = Math.round(mainImage.getBoundingClientRect().height);
    if (height > 0) gallery.style.setProperty('--gallery-media-size', `${height}px`);
  });
};

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainWrap = gallery.querySelector('.main-image-wrap');
  const buttons = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
  if (!mainWrap || buttons.length < 2) return;
  let startX = null;

  const showByOffset = (offset) => {
    const active = gallery.querySelector('[data-gallery-index].is-active');
    const current = Math.max(0, buttons.findIndex((button) => button === active));
    const next = (current + offset + buttons.length) % buttons.length;
    buttons[next]?.click();
  };

  mainWrap.addEventListener('touchstart', (event) => {
    startX = event.touches[0]?.clientX ?? null;
  }, { passive: true });

  mainWrap.addEventListener('touchend', (event) => {
    if (startX === null) return;
    const endX = event.changedTouches[0]?.clientX ?? startX;
    const distance = endX - startX;
    startX = null;
    if (Math.abs(distance) < 36) return;
    showByOffset(distance < 0 ? 1 : -1);
  }, { passive: true });
});

window.addEventListener('load', syncProductGalleryHeights);
window.addEventListener('resize', syncProductGalleryHeights);
document.querySelectorAll('[data-main-product-image]').forEach((image) => {
  image.addEventListener('load', syncProductGalleryHeights);
});
syncProductGalleryHeights();

const refreshCartCount = async () => {
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
  } catch {
    // Cart count refresh is a nice-to-have; keep the add-to-cart flow quiet if it fails.
  }
};

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;
  const submitter = event.submitter || document.activeElement?.closest('button, input[type="submit"]');
  if (submitter?.closest('.shopify-payment-button')) return;

  event.preventDefault();
  const buyNow = submitter?.hasAttribute('data-buy-now');
  const originalHtml = submitter?.innerHTML;
  if (submitter) {
    submitter.disabled = true;
    submitter.innerHTML = buyNow ? 'Adding...' : 'Added';
  }

  try {
    const response = await fetch(action, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart add failed');
    await refreshCartCount();
    document.dispatchEvent(new CustomEvent('dnd:cart-added'));
    if (buyNow) {
      window.location.href = '/checkout';
      return;
    }
    setTimeout(() => {
      if (submitter) {
        submitter.disabled = false;
        submitter.innerHTML = originalHtml || submitter.innerHTML;
      }
    }, 1200);
  } catch {
    form.submit();
  }
});

document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
  const prev = slider.querySelector('[data-hero-prev]');
  const next = slider.querySelector('[data-hero-next]');
  if (slides.length < 2) return;
  let active = 0;
  const show = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  };
  dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
  prev?.addEventListener('click', () => show(active - 1));
  next?.addEventListener('click', () => show(active + 1));
  if (slider.dataset.heroAutoplay !== 'false') {
    setInterval(() => show(active + 1), Number(slider.dataset.heroInterval || 6500));
  }
});

document.querySelectorAll('[data-scroll-row]').forEach((row) => {
  const track = row.querySelector('[data-scroll-track]');
  const prev = row.querySelector('[data-scroll-prev]');
  const next = row.querySelector('[data-scroll-next]');
  if (!track) return;
  const move = (direction) => {
    track.scrollBy({ left: direction * track.clientWidth * 0.86, behavior: 'smooth' });
  };
  prev?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
});

document.querySelectorAll('[data-countdown]').forEach((timer) => {
  let seconds = Number(timer.dataset.countdown || 31632);
  const cells = {
    h: timer.querySelector('[data-hours]'),
    m: timer.querySelector('[data-minutes]'),
    s: timer.querySelector('[data-seconds]')
  };
  const pad = (value) => String(value).padStart(2, '0');
  const render = () => {
    seconds -= 1;
    if (seconds < 0) seconds = Number(timer.dataset.countdown || 31632);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (cells.h) cells.h.textContent = pad(h);
    if (cells.m) cells.m.textContent = pad(m);
    if (cells.s) cells.s.textContent = pad(s);
  };
  render();
  setInterval(render, 1000);
});

document.querySelectorAll('[data-collection-filter]').forEach((toolbar) => {
  const grid = document.querySelector('[data-product-grid]');
  if (!grid) return;
  const items = Array.from(grid.querySelectorAll('[data-product-item]'));
  const search = toolbar.querySelector('[data-filter-search]');
  const sort = toolbar.querySelector('[data-filter-sort]');
  const panel = toolbar.querySelector('[data-filter-panel]');
  const toggle = toolbar.querySelector('[data-filter-toggle]');
  const priceInput = toolbar.querySelector('[data-price-filter]');
  const priceOutput = toolbar.querySelector('[data-price-output]');
  const countBadge = toolbar.querySelector('[data-filter-count]');
  const activeRow = toolbar.querySelector('[data-active-filters]');
  const empty = document.querySelector('[data-filter-empty]');
  const collectionCount = document.querySelector('[data-collection-count]');
  const state = { query: '', maxPrice: Number(priceInput?.value || Infinity), tags: new Set(), availability: new Set(), sort: 'featured' };

  const renderActive = () => {
    const active = [];
    if (state.query) active.push(`"${state.query}"`);
    if (priceInput && state.maxPrice < Number(priceInput.max)) active.push(`<= ${formatMoney(state.maxPrice)}`);
    state.tags.forEach((tag) => active.push(tag));
    state.availability.forEach((value) => active.push(value === 'available' ? 'In stock' : 'On sale'));
    if (countBadge) countBadge.textContent = active.length ? active.length : '';
    if (!activeRow) return;
    activeRow.innerHTML = active.map((label) => `<button type="button" data-clear-filter>${escapeHtml(label)} &times;</button>`).join('');
  };

  const sortItems = (visible) => {
    const sorted = [...visible];
    if (state.sort === 'price-asc') sorted.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
    if (state.sort === 'price-desc') sorted.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
    if (state.sort === 'new') sorted.sort((a, b) => Number(b.dataset.created) - Number(a.dataset.created));
    if (state.sort === 'rating') sorted.sort((a, b) => Number(b.dataset.rating || 0) - Number(a.dataset.rating || 0));
    if (state.sort === 'discount') sorted.sort((a, b) => Number(b.dataset.discount || 0) - Number(a.dataset.discount || 0));
    if (state.sort === 'title') sorted.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    sorted.forEach((item) => grid.appendChild(item));
  };

  const apply = () => {
    const visible = [];
    items.forEach((item) => {
      const title = (item.dataset.title || '').toLowerCase();
      const tags = (item.dataset.tags || '').split(',');
      const matchesQuery = !state.query || title.includes(state.query.toLowerCase());
      const matchesPrice = Number(item.dataset.price || 0) <= state.maxPrice;
      const matchesTags = !state.tags.size || Array.from(state.tags).some((tag) => tags.includes(tag));
      const matchesAvailability =
        (!state.availability.has('available') || item.dataset.available === 'true') &&
        (!state.availability.has('sale') || item.dataset.sale === 'true');
      const show = matchesQuery && matchesPrice && matchesTags && matchesAvailability;
      item.hidden = !show;
      if (show) visible.push(item);
    });
    sortItems(visible);
    if (empty) empty.hidden = visible.length > 0;
    if (collectionCount) collectionCount.textContent = `${visible.length} items`;
    renderActive();
  };

  toggle?.addEventListener('click', () => {
    if (panel) panel.hidden = !panel.hidden;
  });
  search?.addEventListener('input', () => {
    state.query = search.value.trim();
    apply();
  });
  sort?.addEventListener('change', () => {
    state.sort = sort.value;
    apply();
  });
  priceInput?.addEventListener('input', () => {
    state.maxPrice = Number(priceInput.value);
    if (priceOutput) priceOutput.textContent = formatMoney(state.maxPrice);
    apply();
  });
  toolbar.querySelectorAll('[data-tag-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const tag = button.dataset.tagFilter;
      state.tags.has(tag) ? state.tags.delete(tag) : state.tags.add(tag);
      button.classList.toggle('is-active', state.tags.has(tag));
      apply();
    });
  });
  toolbar.querySelectorAll('[data-availability-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const value = button.dataset.availabilityFilter;
      state.availability.has(value) ? state.availability.delete(value) : state.availability.add(value);
      button.classList.toggle('is-active', state.availability.has(value));
      apply();
    });
  });
  activeRow?.addEventListener('click', (event) => {
    if (!event.target.closest('[data-clear-filter]')) return;
    state.query = '';
    state.tags.clear();
    state.availability.clear();
    if (search) search.value = '';
    toolbar.querySelectorAll('.filter-chips button').forEach((button) => button.classList.remove('is-active'));
    if (priceInput) {
      priceInput.value = priceInput.max;
      state.maxPrice = Number(priceInput.max);
      if (priceOutput) priceOutput.textContent = formatMoney(state.maxPrice);
    }
    apply();
  });
});

document.querySelectorAll('[data-cart-form]').forEach((form) => {
  const giftToggle = form.querySelector('[data-gift-toggle]');
  const giftNote = form.querySelector('[data-gift-note]');
  const noteInput = giftNote?.querySelector('textarea');
  const noteCount = form.querySelector('[data-note-count]');
  const discountInput = form.querySelector('[data-discount-input]');
  const discountButton = form.querySelector('[data-discount-apply]');
  const discountMessage = form.querySelector('[data-discount-message]');

  giftToggle?.addEventListener('change', () => {
    if (giftNote) giftNote.hidden = !giftToggle.checked;
  });
  noteInput?.addEventListener('input', () => {
    if (noteCount) noteCount.textContent = `${noteInput.value.length}/200`;
  });
  discountButton?.addEventListener('click', () => {
    const code = discountInput?.value.trim().toUpperCase();
    if (!discountMessage) return;
    discountMessage.textContent = code ? `${code} will be applied at checkout.` : 'Enter a coupon code first.';
  });
});

document.querySelectorAll('[data-purchase-toast]').forEach((toast) => {
  const configScript = toast.parentElement?.querySelector('[data-purchase-toast-config]');
  const close = toast.querySelector('[data-purchase-toast-close]');
  const name = toast.querySelector('[data-purchase-name]');
  const city = toast.querySelector('[data-purchase-city]');
  const product = toast.querySelector('[data-purchase-product]');
  const time = toast.querySelector('[data-purchase-time]');
  const interval = Math.max(3000, Number(toast.dataset.purchaseInterval || 6000));
  const delay = Math.max(0, Number(toast.dataset.purchaseDelay || 0));
  let config = {};
  try {
    config = configScript ? JSON.parse(configScript.textContent) : {};
  } catch {
    config = {};
  }

  const clean = (items, fallback) =>
    (Array.isArray(items) ? items : [])
      .map((item) => String(item).trim())
      .filter(Boolean)
      .concat([fallback]);
  const names = clean(config.names, 'Priya');
  const cities = clean(config.cities, 'Pune');
  const products = clean(config.products, 'Blush Cloud Tumbler');
  const times = clean(config.times, '2 mins ago');
  let index = 0;
  let closed = false;

  const render = () => {
    if (closed) return;
    if (name) name.textContent = names[index % names.length];
    if (city) city.textContent = cities[index % cities.length];
    if (product) product.textContent = `just ordered ${products[index % products.length]}`;
    if (time) time.textContent = times[index % times.length];
    index += 1;
    toast.classList.remove('is-hidden');
  };

  toast.classList.add('is-hidden');
  const showTimer = setTimeout(render, delay);
  const rotateTimer = setInterval(render, interval);
  close?.addEventListener('click', () => {
    closed = true;
    clearTimeout(showTimer);
    clearInterval(rotateTimer);
    toast.classList.add('is-hidden');
  });
});

document.querySelectorAll('[data-review-bank]').forEach((bank) => {
  const configScript = bank.parentElement?.querySelector('[data-review-config]');
  const grid = bank.querySelector('[data-review-grid]');
  const button = bank.querySelector('[data-review-load]');
  if (!configScript || !grid || !button) return;

  let config;
  try {
    config = JSON.parse(configScript.textContent);
  } catch {
    return;
  }

  const total = Math.max(0, parseInt(String(config.total || 0).replace(/[^\d]/g, ''), 10) || 0);
  const initial = Math.max(1, Number(config.initial || 8));
  const perLoad = Math.max(1, Number(config.perLoad || 8));
  const imageNodes = bank.parentElement?.querySelectorAll('[data-review-image]') || [];
  const images = Array.from(imageNodes).map((node) => node.dataset.reviewImage).filter(Boolean);
  const names = [
    'Md', 'Gaurav', 'Kanika', 'Aanya', 'Ritika', 'Neha', 'Ishita', 'Aarav',
    'Pooja', 'Sakshi', 'Aditi', 'Riya', 'Sneha', 'Divya', 'Palak', 'Naina',
    'Megha', 'Anjali', 'Komal', 'Tanya', 'Bhavna', 'Ayesha', 'Kajal', 'Juhi'
  ];
  const reviews = [
    'Wow, better than expected.',
    'Good quality for the price.',
    'Excellent service and smooth delivery.',
    'Looks premium and well finished.',
    'Feels premium in real life.',
    'Clean design, really loved it.',
    'Perfect for daily use.',
    'Bought it as a gift and they loved it.',
    'Totally worth it.',
    'The overall look is really impressive.',
    'Packaging was neat and secure.',
    'Arrived on time and in great condition.',
    'Exactly as shown in the photos.',
    'Super easy to use and works well.',
    'Nice details, looks more expensive.',
    'Great value for money.',
    'Comfortable and practical.',
    'Customer support was helpful.',
    'Would happily order again.',
    'The finish is much better than expected.'
  ];
  const randomFrom = (items) => items[Math.floor(Math.random() * items.length)];
  const generateDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - Math.floor(Math.random() * 45));
    return date.toLocaleDateString('en-GB');
  };
  const imageRatio = 0.3;
  const imageTarget = images.length ? Math.min(total, Math.floor(total * imageRatio)) : 0;
  const imagePositions = new Set();
  if (imageTarget > 0) {
    const positions = Array.from({ length: total }, (_, index) => index);
    for (let i = positions.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [positions[i], positions[j]] = [positions[j], positions[i]];
    }
    for (let i = 0; i < imageTarget; i += 1) imagePositions.add(positions[i]);
  }
  let shown = 0;
  let imageIndex = 0;

  const card = (index) => {
    const name = randomFrom(names);
    const text = randomFrom(reviews);
    const date = generateDate();
    const image = imagePositions.has(index) && images.length ? images[imageIndex++ % images.length] : '';
    return `
      <article class="review-card">
        ${image ? `<figure><img src="${escapeHtml(image)}" alt="Customer review photo" loading="lazy"></figure>` : ''}
        <div class="review-card__body">
          <div class="review-card__top">
            <span class="review-card__name">${escapeHtml(name)}</span>
            <span class="review-verified">Verified</span>
          </div>
          <div class="review-card__date">${escapeHtml(date)}</div>
          <div class="review-card__stars" aria-label="5 out of 5 stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
          <div class="review-card__text">${escapeHtml(text)}</div>
        </div>
      </article>
    `;
  };

  const render = (count) => {
    const target = Math.min(total || count, shown + count);
    const html = [];
    for (let i = shown; i < target; i += 1) html.push(card(i));
    grid.insertAdjacentHTML('beforeend', html.join(''));
    shown = target;
    button.hidden = shown >= total || total === 0;
    if (total === 0) {
      grid.innerHTML = '<div class="collection-empty"><h3>No reviews yet.</h3></div>';
    }
  };

  render(Math.min(initial, total || initial));
  button.addEventListener('click', () => render(perLoad));
});
